import { useState } from 'react'
import dataSelectField from '@templates/AddNewItemModal/templates/dataSelectField'
import { useGetDangerKindsQuery } from '@services/dangerKinds'
import { UseDangerField } from '@app-types/riskMapFields'

const useDangerKindsField: UseDangerField = ({
  params,
  onOneItem,
  skip,
  initFilters,
}) => {
  const [filters, setFilters] = useState(initFilters)

  return {
    setFilters,
    field: (fieldParams) =>
      dataSelectField({
        query: useGetDangerKindsQuery,
        filters,
        setFilters,
        dropdownWidth: 500,
        label: 'Вид опасности',
        name: 'kind',
        withManualEntryText: true,
        withShowLabelInDescription: true,
        onOneItem,
        skip,
        ...params,
        ...fieldParams,
      }),
  }
}

export default useDangerKindsField
